import type { MeshSnapshot } from "../../domain/mesh";
import { mockEdges } from "./edges";
import { createMockEvents } from "./events";
import { createMockNodes } from "./nodes";
import { createMockOrbitals } from "./orbitals";
import { mockProjection } from "./projection";

export { createPulse } from "./events";

export function createMockSnapshot(origin = Date.now()): MeshSnapshot {
  return {
    schemaVersion: 2,
    generatedAt: new Date(origin).toISOString(),
    revision: "KX-0110 / CONNECTED-GRAPH-PASS",
    nodes: createMockNodes(origin),
    orbitals: createMockOrbitals(origin),
    edges: mockEdges,
    events: createMockEvents(origin),
    projection: mockProjection,
  };
}

export const mockSnapshot = createMockSnapshot();
